import { createContext, useContext, useEffect, useState, useCallback } from 'react';

// Lightweight theme mechanism. Phase 1: stores the user's preference, persists it to
// localStorage (for no-flash on load) and applies `data-theme` + a `light`/`dark` class to
// <html>. The new Account/Login surfaces are theme-aware; the rest of the tools are migrated
// to honor this in a follow-up. Default is dark.

const ThemeContext = createContext({ theme: 'dark', setTheme: () => {} });
export const useTheme = () => useContext(ThemeContext);

function apply(theme) {
  const el = document.documentElement;
  el.setAttribute('data-theme', theme);
  el.classList.toggle('dark', theme === 'dark');
  el.classList.toggle('light', theme === 'light');
  // Keep the standalone/browser status-bar tint in sync with the in-app theme.
  const tc = document.querySelector('meta[name="theme-color"]');
  if (tc) tc.setAttribute('content', theme === 'light' ? '#f4f4f5' : '#18181b');
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try { return localStorage.getItem('ology-theme') || 'dark'; } catch { return 'dark'; }
  });

  useEffect(() => { apply(theme); }, [theme]);

  const setTheme = useCallback((t) => {
    const next = t === 'light' ? 'light' : 'dark';
    setThemeState(next);
    try { localStorage.setItem('ology-theme', next); } catch {}
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
